// Import all images as ES modules
import burger from './img/burger.svg';
import close_blue from './img/close-blue.svg';
import close_gray from './img/close-gray.svg';
import close from './img/close.svg';
import download from './img/download.svg';
import enter from './img/enter.svg';
import eye from './img/eye.svg';
import letter from './img/letter.svg';
import logo_blue from './img/logo-blue.svg';
import logo from './img/logo.svg';
import mail from './img/mail.svg';
import news from './img/news.jpg';
import person from './img/person.svg';
import phone from './img/phone.svg';
import photo_without_plus from './img/photo-without-plus.svg';
import star from './img/star.svg';
import checkMarkGreen from './img/check-mark-green.svg';
import clock from './img/clock.svg';
import star_full from './img/star-full.svg';
import reject from './img/reject.svg';
import eye_invisible from './img/eye-invisible.svg';
import expired from './img/expired.svg';

const images = {
  burger,
  close_blue,
  close_gray,
  close,
  download,
  enter,
  eye,
  letter,
  logo_blue,
  logo,
  mail,
  news,
  person,
  phone,
  photo_without_plus,
  star,
  checkMarkGreen,
  clock,
  star_full,
  reject,
  eye_invisible,
  expired,
};
export default images;
